import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import useFileUpload from '../../../../../hooks/useFileUpload';
import { CircularProgress, Box, Typography } from '@material-ui/core';
import {useAuth} from "../../../../../contexts/AuthContext";

function CircularProgressWithLabel(props) {
    return (
      <Box position="relative" display="inline-flex">
        <CircularProgress variant="determinate" {...props} />
        <Box
          top={0}
          left={0}
          bottom={0}
          right={0}
          position="absolute"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Typography variant="caption" component="div" color="textSecondary">{`${Math.round(
            props.value,
          )}%`}</Typography>
        </Box>
      </Box>
    );
  }
  
  CircularProgressWithLabel.propTypes = {
    /**
     * The value of the progress indicator for the determinate variant.
     * Value between 0 and 100.
     */
    value: PropTypes.number.isRequired,
  };

export default function UploadProgress({file, setFile, uploadFor, setCheck, setUrl, setPathname}) {
    const {currentUser} = useAuth();
    const {progress, url, pathname, error} = useFileUpload(file,uploadFor, currentUser.uid);

    useEffect(() => {
        if (url && pathname) {
            setFile(null);
            setCheck(true);
            setUrl(url);
            setPathname(pathname);
        }
    }, [url,setFile, setCheck, setUrl, setPathname, pathname]);

    return (
        <div>
            {error && <Typography variant="body1">{error}</Typography>}
            <CircularProgressWithLabel value={progress} />
        </div>
    )
}
